export default {
  title: {
    rules: [
      {
        required: true,
        message: "Введите название",
        trigger: "blur"
      }
    ]
  },
  key: {
    rules: [
      {
        required: true,
        message: "Введите ключ валюты",
        trigger: "blur"
      }
    ]
  },
  categories: {
    rules: [
      {
        required: true,
        message: "Выберите категории",
        trigger: ["change", "blur"]
      }
    ]
  },
  form_title: {
    rules: [
      {
        required: true,
        message: "Выберите название",
        trigger: "blur"
      }
    ]
  },
  form_step: {
    rules: [
      {
        required: true,
        message: "Не задан шаг вывода формы",
        trigger: "blur"
      }
    ]
  },
  form_type: {
    rules: [
      {
        required: true,
        message: "Не задан тип формы",
        trigger: "blur"
      }
    ]
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/Valutes/validation.js